<script lang="ts">
	import { page } from '$app/state'

	let { link = undefined, copy = undefined, alt = undefined } = $props()

	let url = $derived(link || page.url.toString())
	let text = $derived(copy || page.data?.story?.name)

	function share() {
		navigator
			.share({
				title: 'Bedales School',
				text,
				url
			})
			.then(() => console.log('Shared successfully'))
			.catch(error => console.error('Error sharing:', error))
	}
</script>

<div class="share theme-crocus-on-light-gimson" class:alt>
	<div class="contain" class:alt>
		<div class="title" class:alt>Share via</div>
		<a
			class="icon"
			href="https://www.linkedin.com/sharing/share-offsite/?url={url}"
			target="_blank"
			rel="noopener noreferrer"
			aria-label="Share on LinkedIn"
		>
			<svg class="svg"><use xlink:href="/images/vector.svg#linkedin"></use></svg>
		</a>
		<a
			class="icon"
			href="https://www.facebook.com/sharer/sharer.php?u={url}"
			target="_blank"
			rel="noopener noreferrer"
			aria-label="Share on Facebook"
		>
			<svg class="svg"><use xlink:href="/images/vector.svg#facebook"></use></svg>
		</a>
		<button class="icon" onclick={share} aria-label="Share Link">
			<svg class="svg"><use xlink:href="/images/vector.svg#link"></use></svg>
		</button>
	</div>
</div>

<style lang="css">
	.share {
		background-color: var(--c-background);
		color: var(--c-midground);
		padding-block: 1.5rem;

		&.alt {
			background-color: unset;
			color: var(--c-black);
			padding-block: 0;
			text-align: center;
		}
	}

	.contain {
		align-items: center;
		display: flex;
		gap: 1.75rem;
		justify-content: center;

		&.alt {
			flex-wrap: wrap;
			column-gap: 1.5rem;
			row-gap: 0.75rem;
		}
	}

	.title {
		font: 500 var(--f-body1);
		letter-spacing: var(--ls-body1);
		text-transform: uppercase;

		&.alt {
			flex: 1 0 100%;
		}
	}

	.icon {
		color: var(--c-foreground);
		size: 2rem;
	}

	.svg {
		size: 100%;
	}
</style>
